import React, { useEffect, useState } from "react";
import { PageLoader, StatusBadge, SmartImage } from "../../components/shared";
import { Button } from "../../components/ui/button";
import { Star, EyeSlash, Eye } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { money, apiErr } from "../../lib/api";

export default function AdminEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/events").then((r) => setEvents(r.data.events)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try { const { data } = await api.post(`/admin/events/${id}/${action}`); toast.success(data.message); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (loading) return <PageLoader />;

  return (
    <div>
      <div className="overline mb-1">Moderation</div>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mb-6">Events</h1>
      <div className="rounded-xl border border-border bg-card divide-y divide-border">
        {events.map((e) => (
          <div key={e.id} className="flex items-center gap-4 p-3" data-testid={`admin-event-${e.id}`}>
            <div className="w-20 shrink-0"><SmartImage src={e.banner} alt={e.title} ratio="video" /></div>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{e.title} {e.is_featured && <Star weight="fill" className="inline text-primary" size={14} />}</div>
              <div className="text-sm text-muted-foreground truncate">{e.city} · {e.organizer_name} · {e.sold} sold</div>
            </div>
            <StatusBadge status={e.status} />
            <div className="flex items-center gap-1">
              {e.is_featured
                ? <Button size="sm" variant="outline" onClick={() => act(e.id, "unfeature")}><Star size={14} className="mr-1" /> Unfeature</Button>
                : <Button size="sm" variant="outline" onClick={() => act(e.id, "feature")} data-testid={`feature-${e.id}`}><Star size={14} className="mr-1" /> Feature</Button>}
              {e.status === "published" && <Button size="sm" variant="ghost" onClick={() => act(e.id, "unpublish")} className="text-destructive"><EyeSlash size={14} /></Button>}
            </div>
          </div>
        ))}
        {events.length === 0 && <div className="p-8 text-center text-muted-foreground text-sm">No events.</div>}
      </div>
    </div>
  );
}
